import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appOnlyDigitsLengthValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: OnlyDigitsLengthValidatorDirective, multi: true }
  ]
})
export class OnlyDigitsLengthValidatorDirective implements Validator {
  @Input() minLength = 0;
  @Input() maxLength = Infinity;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const apenasNumeros = input.value.replace(/\D/g, '');
    if (apenasNumeros.length > this.maxLength && isFinite(this.maxLength)) {
      event.preventDefault();
      event.stopPropagation();
      const valorAnterior = input.value.slice(0, -1);
      input.value = valorAnterior;
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
      nativeInputValueSetter?.call(input, valorAnterior);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const apenasNumeros = String(control.value || '').replace(/\D/g, '');
    this.clearPreviousValidations(control);

    if (apenasNumeros.length < this.minLength) {
      return { minlength: { requiredLength: this.minLength, actualLength: apenasNumeros.length } };
    }
    if (apenasNumeros.length > this.maxLength) {
      return { maxlength: { requiredLength: this.maxLength, actualLength: apenasNumeros.length } };
    }
    return null;
  }

  clearPreviousValidations(control: AbstractControl) {
    if (control.errors) {
      delete control.errors['minlength'];
      delete control.errors['maxlength'];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }
}